import { create } from "zustand";

import type { BlockDragVisual } from "../features/calendar-view/drag.js";

/** Live state for a cross-day bottom-edge resize. The gesture (in `useTaskResize`)
 *  reports the FIXED start instant and the CURRENT dragged end instant; the grid
 *  (`TimeAxisGrid`) reads it to paint a ghost spanning the affected day columns,
 *  so a 2h task can be dragged out to span several days before commit. The source
 *  block (and any continuation segments) dim while their id matches `taskId`. */
export interface ResizePreview {
  taskId: string;
  /** Task start instant (epoch ms) — fixed for the whole gesture. */
  startMs: number;
  /** Current dragged end instant (epoch ms). */
  endMs: number;
  /** Block look (wash vars / tone), captured at gesture start. */
  visual: BlockDragVisual;
}

interface ResizePreviewState {
  preview: ResizePreview | null;
  setPreview: (p: ResizePreview | null) => void;
}

export const useResizePreviewStore = create<ResizePreviewState>((set) => ({
  preview: null,
  setPreview: (preview) => set({ preview }),
}));
